import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Checkbox from 'Components/UI/Checkbox';
import CheckIcon from '@material-ui/icons/Check';

const styles = (theme) => ({
  root: {
    width: '100%',
    borderRadius: theme.radius.md,
    color: theme.palette.facet.primaryBlue,
    backgroundColor: theme.palette.facet.accentBlue21,
    textAlign: 'center',
    justifyContent: 'center',
    margin: theme.spacing(0, 0, 2, 0),
    padding: theme.spacing(3.5, 1.5),
    '& .MuiCheckbox-root': { // <--- Hides the default radio input
      opacity: 0,
      position: 'fixed',
      width: 0,
    },
    userSelect: 'none',
  },
  checkboxButtonSelected: {
    width: '100%',
    borderRadius: theme.radius.md,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.facet.primaryBlue,
    transition: 'background-color 0.3s ease-in-out',
  },
  checkboxLabel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  formControlLabel: {},
  formControlLabelWithIcon: {
    marginRight: theme.spacing(1),
  },
  endIcon: {
    position: 'absolute',
    right: theme.spacing(1.5),
  },
});

const CheckboxButton = ({
  className,
  classes,
  checked,
  label,
  onChange,
  SelectedEndIcon,
  ...rest
}) => {
  const showEndIcon = !!SelectedEndIcon && checked;

  return (
    <FormControlLabel
      className={classNames(classes.root, className, {
        [classes.checkboxButtonSelected]: checked,
      })}
      control={(
        <Checkbox
          checked={checked}
          onChange={onChange}
        />)
      }
      label={(
        <div className={classes.checkboxLabel}>
          <Typography
            className={classNames(classes.formControlLabel, {
              [classes.formControlLabelWithIcon]: !!SelectedEndIcon,
            })}
            weight={'bold'}
            variant={'h5'}
          >
            {label}
          </Typography>
          {showEndIcon && (
            <SelectedEndIcon
              className={classes.endIcon}
            />)
          }
        </div>)
      }
      {...rest}
    />
  );
};

CheckboxButton.defaultProps = {
  className: '',
  SelectedEndIcon: CheckIcon,
};

CheckboxButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  SelectedEndIcon: PropTypes.object,
};

export default withStyles(styles)(CheckboxButton);
